import { useMediaQuery, FormControl, FormLabel, FormHelperText } from "@material-ui/core";
import 'Agent/AgentForms/Marketing/components/MarketingViewCart.sass';
import 'Agent/AgentForms/Marketing/components/SearchForm.sass';
import React from "react";
import VerticalLinearStepper from 'Agent/AgentForms/Marketing/components/StepCart';
import { MarketingViewCart } from 'Agent/AgentForms/Marketing/ducks/Marketing';
import { useDispatch } from "react-redux";

export type ViewCartProps = {
    setIsViewCartBlock: (value: boolean | ((isViewCartBlock: boolean) => boolean)) => void;
    viewCartDetails: MarketingViewCart;
}

const MarketingViewCartForm = ({ setIsViewCartBlock, viewCartDetails }: ViewCartProps) => {

    const handleClose = () => {
        setIsViewCartBlock(false);
    }

    const isDesktop = useMediaQuery((theme: any) => theme.breakpoints.up('lg'));
    const dispatch = useDispatch();
    const handleMobile = () => {
        return isDesktop ? "viewcart-form-desktop-view" : "card-filter-overlay slideIn"
    }

    return (
        <div className={handleMobile()}>
            <div className="drawer-sections">
                <div className="dropdown-section">
                    <FormControl component="fieldset" className="drawer-title">
                        <div className="form-control-label">
                            <FormLabel id="marketing-forms-drawer-title" component="legend"
                                className="form-drawer-label">Form Cart</FormLabel>
                            <span className="close-button"
                                onClick={handleClose}>
                                <i className="fa fa-times" aria-hidden="true" />
                            </span>
                        </div>
                    </FormControl>
                    <div className="field-section-body">
                        <VerticalLinearStepper setIsViewCartBlock={setIsViewCartBlock} viewCartDetails={viewCartDetails} />
                    </div>
                    <FormControl className="field-section-last">
                        <FormHelperText id="component-helper-text" className="viewcart-margintop-xl">

                        </FormHelperText>
                    </FormControl>
                </div>
            </div>
        </div>
    );
}

export default MarketingViewCartForm;
